/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Gateway-dispatched execution activity for one member server.
 */
export type MetaMcpMemberUsage = {
  /**
   * Calls that returned an HTTP error status
   */
  errorCount: number;
  /**
   * ISO 8601 timestamp of the most recent call
   */
  lastCalledAt?: Date | undefined;
  /**
   * The member's mcp_servers row id
   */
  mcpServerId: string;
  /**
   * Tool calls dispatched to this member through the gateway
   */
  toolCalls: number;
};

/** @internal */
export const MetaMcpMemberUsage$inboundSchema: z.ZodMiniType<
  MetaMcpMemberUsage,
  unknown
> = z.pipe(
  z.object({
    error_count: z.int(),
    last_called_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    mcp_server_id: z.string(),
    tool_calls: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "error_count": "errorCount",
      "last_called_at": "lastCalledAt",
      "mcp_server_id": "mcpServerId",
      "tool_calls": "toolCalls",
    });
  }),
);

export function metaMcpMemberUsageFromJSON(
  jsonString: string,
): SafeParseResult<MetaMcpMemberUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetaMcpMemberUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetaMcpMemberUsage' from JSON`,
  );
}
